import { render } from "./SuperAdminView.vue?vue&type=template&id=07b8fe5b"
import script from "./SuperAdminView.vue?vue&type=script&lang=js"
export * from "./SuperAdminView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__